import { useQuery } from "@tanstack/react-query";
import { FileIcon } from "lucide-react";

import { formatDateAt } from "simplydo/core/dates";
import { initUseQuery } from "simplydo/core/query";
import { ButtonLink } from "simplydo/react/ui/button";
import { H3, H4, Subheader } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";

import api from "api";
import { useAppSelector } from "store";

import {
  HomeRow,
  HomeRowActions,
  HomeRowContainer,
  HomeRowContent,
  HomeRowIcon,
} from "../HomeUI";
import HomeBlock from "./HomeBlock";

const PagesBlock = () => {
  const user = useAppSelector((state) => state.user);
  const orgId = user?.organisation;

  const pagesQuery = useQuery(
    initUseQuery(api.pages.getPinned, ["organisation", orgId!], {
      isEnabled: !!orgId,
    }),
  );

  const pinnedPages = pagesQuery.data?.pages ?? [];

  if (!pinnedPages.length) return null;

  return (
    <HomeBlock>
      <H3>
        Other resources
        <Subheader>
          Quick links to organisational content supplied by your organisation.
        </Subheader>
      </H3>
      <HomeRowContainer>
        {pinnedPages.map((page) => (
          <HomeRow
            key={page._id}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <HomeRowIcon>
              <Icon icon={FileIcon} />
            </HomeRowIcon>
            <HomeRowContent>
              <H4>
                {page.title}
                <Subheader>
                  Posted: {formatDateAt(page.updatedAt ?? page.createdAt)}
                </Subheader>
              </H4>
            </HomeRowContent>
            <HomeRowActions>
              <ButtonLink
                color="primary"
                variant="soft"
                size="small"
                to={page.link!}
              >
                Open
              </ButtonLink>
            </HomeRowActions>
          </HomeRow>
        ))}
      </HomeRowContainer>
    </HomeBlock>
  );
};

export default PagesBlock;
